import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageHero";

const CHANNELS = [
  { icon: Mail, label: "Email", value: "info@noeticalab.gr", href: null },
  { icon: Phone, label: "Τηλέφωνο", value: "+30 210 000 0000", href: "tel:+302100000000" },
  { icon: MapPin, label: "Έδρα", value: "Ιωάννινα, Ελλάδα", href: null },
  { icon: Clock, label: "Ωράριο", value: "Δευτέρα – Παρασκευή, 09:00 – 17:00", href: null },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Επικοινωνία"
        title="Θέλεις να μάθεις περισσότερα;"
        text="Επικοινώνησε μαζί μας για πληροφορίες σχετικά με τις εκδόσεις, τα ψηφιακά εργαλεία και τα σεμινάρια."
      />

      <section className="pb-24 sm:pb-32 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {CHANNELS.map((c, i) => (
              <Reveal key={c.label} delay={i * 0.07}>
                <div className="group border border-ink/10 bg-sand p-7 h-full transition-transform duration-300 hover:-translate-y-1.5" data-testid={`contact-channel-${c.label}`}>
                  <span className="w-11 h-11 inline-flex items-center justify-center rounded-full bg-ink text-cream transition-colors duration-300 group-hover:bg-terracotta">
                    <c.icon className="w-4.5 h-4.5" />
                  </span>
                  <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-terracottaD mt-6">{c.label}</p>
                  {c.href ? (
                    <a href={c.href} className="block font-display text-lg font-semibold mt-2 hover:text-terracotta transition-colors duration-300 break-all">
                      {c.value}
                    </a>
                  ) : (
                    <p className="font-display text-lg font-semibold mt-2">{c.value}</p>
                  )}
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-16 bg-ink text-cream p-8 sm:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <p className="eyebrow text-terracotta">Σημείωμα</p>
                <h2 className="font-display text-2xl sm:text-3xl font-bold mt-3">Προτιμάς γραπτώς;</h2>
                <p className="text-cream/70 leading-relaxed mt-4 text-sm sm:text-base">
                  Στείλε μας email με το θέμα που σε ενδιαφέρει — έκδοση, εργαλείο ή σεμινάριο — και θα σου απαντήσουμε το
                  συντομότερο δυνατό.
                </p>
              </div>
              <div className="lg:justify-self-end">
                <p data-testid="contact-email-text" className="inline-flex items-center gap-2.5 text-cream font-display text-xl sm:text-2xl font-semibold">
                  <Mail className="w-5 h-5 text-terracotta" />
                  info@noeticalab.gr
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
